// AutoGenerated
export enum EnmKatilimBildirmeDurum {
    "Katılamıyorum" = 1,
    "Belirsiz" = 2,
    "Katılacağım" = 3,
}